export default __webpack_public_path__ + "static/media/thumbup.e06790ba.png";